import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const CornerDownRightIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Corner Down Icon</title>;
    t1 = <path d="M5.04409 5.46813L0.233872 5.13372L4.36247 0.694724L5.04409 5.46813Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};